import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import classNames from "classnames";
import { app, appStore } from "../../App";
import { UnstakeAction } from "../../eos/actions/UnstakeAction";
import { formatTimeLeft } from "../../helpers/formatters";
import { L } from "../../l10n/L10n";
import { StakedAssetModel } from "../../stores/StakedAssetModel";
import { AssetExaminerMode } from "./AssetExaminer";
import AssetImg from "./AssetImg";
import { AssetImgActive } from "./AssetImgActive";
import Styles from "./AssetView.module.scss";
import { GameButton, GameButtonStyleType } from "./GameButton";

type AssetViewStakedPropsType = {
	mode: AssetExaminerMode
	asset: StakedAssetModel

	preview?: boolean
}

const AssetViewStaked = observer(({asset, mode, preview}: AssetViewStakedPropsType) => {
	const [btnReady, setBtnReady] = useState(true);
	const [timeLeft, setTimeLeft] = useState(asset.secondsToAction);

	const timerValue = formatTimeLeft(timeLeft);
	const isEnchanting = timeLeft > 0;
	const active = appStore?.activeCard?.assetId === asset.assetId;
	const setActiveCard = appStore.setActiveCard;

	function onBtnClick() {
		setBtnReady(false);
		new UnstakeAction(asset.assetId)
			.onSuccess(() => app.showInfo(L.common.success))
			.onError(() => setBtnReady(true))
			.executeAsync();
	}

	useEffect(() => {
		const intervalId = setInterval(() => {
			setTimeLeft(asset.secondsToAction);
		}, 1000);

		return () => clearInterval(intervalId);
	}, [asset]);

	return (
		<div
			className={classNames(
				Styles.assetViewContainer,
				{[Styles.assetActive]: !preview && active},
				{[Styles.assetPreview]: preview},
			)}
			onClick={mode === "ONLY_STAKED" ? () => setActiveCard(asset) : undefined}
		>
			{isEnchanting && <AssetImgActive timer={timerValue}/>}
			<AssetImg img={asset.img} name={asset.name} preview={preview}/>

			{mode === "ALL" &&
			 <GameButton
				 onClick={onBtnClick}
				 text={L.common.unstake}
				 style={GameButtonStyleType.UNSTAKE}
				 extraStyles={Styles.styleAssetButton}
				 ready={btnReady}
			 />}
		</div>
	);
});

export default AssetViewStaked;
